import { createSlice } from '@reduxjs/toolkit';

import { fetcherInitialState } from '../fetcher';
import { SalutationsFetcher } from './thunk';

const initialState = fetcherInitialState;

export const salutationsSlice = createSlice({
    name: 'salutations',
    initialState,
    reducers: {},
    extraReducers(builder) {
        SalutationsFetcher.reducers(builder);
    },
});

export default salutationsSlice.reducer;
